module.exports = "\n\n<jira-cms-tasks ></jira-cms-tasks>"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/project/jiraCMSManager-ang7/jira-cms-manager.component.html
// module id = 1786
// module chunks = 0